import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { SiteSelectorContextProvider } from "@/components/site-selector-modal";
import {
    JiraSoftwareFeaturesPageTemplate,
    JiraSoftwareFeaturesPageTemplateV2
} from "@/templates/software/jira/features/jira-software-features-page/src";

export const JiraSoftwareFeaturesPage = () => {
    const showJiraSoftwareFeaturesV2 =
        FeatureGates.checkGate("wac-jira-features-team24-gate") ?? false;

    return (
        <SiteSelectorContextProvider
            analyticsPrefix="jsm.show"
            productKey={ProductKeys.JIRA_SOFTWARE}
        >
            {showJiraSoftwareFeaturesV2 ? (
                <JiraSoftwareFeaturesPageTemplateV2 />
            ) : (
                <JiraSoftwareFeaturesPageTemplate />
            )}
        </SiteSelectorContextProvider>
    );
};
